module.exports = __webpack_public_path__ + "img/portfolio-4.70fae66f.jpg";